import request from '@/utils/request'

/**
 * 大屏显示-员工画像(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function onjobMemberPortraitGet(data) {
  return request({
    type: 'biz',
    url: 'onjob/member/portrait/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/OnjobMember.js